export default __webpack_public_path__ + "static/media/empty-wishlist.7e1ca706.jpg";